export default __webpack_public_path__ + "static/media/kgv-overview.6ac6609f.jpg";